import { render, staticRenderFns } from "./ApproveAuctionModal.vue?vue&type=template&id=53221a30"
import script from "./ApproveAuctionModal.vue?vue&type=script&lang=ts"
export * from "./ApproveAuctionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports